module.exports = __webpack_public_path__ + "img/ic-list-select-delete.660d3d3a.svg";